import { AlertFactory } from 'alerts/Alert'
import DocumentStore from 'documents/DocumentStore'
import DocumentTagStore from 'documents/DocumentTagStore'
import DocumentTypeStore from 'documents/DocumentTypeStore'
import { DocumentActionsAdapter } from 'documents/DocumentActionsAdapter'
import Job from 'jobs/Job'
import DocumentType from 'documents/DocumentType'
import { computed, makeObservable } from 'mobx'
import { Id } from 'types/definitions'
import { DocumentJobCreationOpts } from 'documents/dtos/document'

/**
 * Adapter for Job Documents
 */
export class JobDocumentsAdapter {
  constructor(
    private documentStore: DocumentStore,
    private documentTagStore: DocumentTagStore,
    private documentTypeStore: DocumentTypeStore,
    public documentActionsAdapter: DocumentActionsAdapter,
    public newAlert: AlertFactory,
  ) {
    makeObservable(this)
  }

  @computed
  get documentTags() {
    return this.documentTagStore.tags
  }

  @computed
  get documentTypes() {
    return this.documentTypeStore.types
  }

  getJobDocuments(jobId: string) {
    return this.documentStore.forJob(jobId)
  }

  getScrollProvider(jobId: string) {
    return this.documentStore.getScrollProvider(jobId, (params) =>
      this.documentStore.findDocuments({
        context: 'Job',
        accesses: true,
        tags: true,
        job_id: jobId,
        ...params,
      }),
    )
  }

  async fetchTags() {
    await this.documentTagStore.fetchTags()
  }

  makeAccessOptions(
    job: Job,
    type: DocumentType | undefined,
  ): DocumentJobCreationOpts {
    return {
      access: {
        type: 'Job',
        job_id: Id.assert(job.id),
      },
      document_type_id: type ? Id.assert(type.id) : undefined,
      workspace_id: Id.assert(job.workspace.id),
    }
  }
}
